<template>
  <drag-dialog
    :title="title"
    :width="750"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="custom-tabs-box">
      <div class="tabs-item-box">
        <div
          :class="`tab-box dialog-label ${
            isActive('changeLogs') ? 'active-item' : ''
          }`"
          @click="onTabClick('changeLogs')">
          变更日志({{ changeLogs.length }})
        </div>
        <div
          v-if="isChecked('DataSet.VersionContrast.QueryList')"
          :class="`tab-box dialog-label ${
            isActive('versionCompare') ? 'active-item' : ''
          }`"
          @click="onTabClick('versionCompare')">
          版本对比
        </div>
      </div>
      <div class="tabs-content-box">
        <div
          class="changes-box"
          v-if="activeTab === 'changeLogs'">
          <div
            class="common-table-box"
            v-if="activeTab === 'changeLogs'">
            <el-table
              highlight-selection-row
              :data="changeLogs"
              :header-row-class-name="customHeader"
              ref="modelTable"
              class="publish-small-table publish-table"
              height="100%">
              <el-table-column
                label="版本号"
                width="180">
                <template v-slot="{ row }">{{ `V${row.version}` }}</template>
              </el-table-column>
              <el-table-column label="转换完成时间">
                <template v-slot="{ row }">
                  <span>{{ formatTime(row.convertCompleteTime) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="120">
                <template v-slot="{ row }">
                  <div class="operation-cell">
                    <el-button
                      type="text"
                      size="small"
                      @click="viewModel(row)"
                      >查看模型</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div
          class="compare-box"
          v-if="activeTab === 'versionCompare'">
          <div
            v-if="compareLoading"
            class="loading-box">
            <Spin
              :pointNum="8"
              :translateX="25"
              background="var(--base-primary-bgColor)" />
          </div>
          <div
            v-else
            class="compare-content-box">
            <div v-if="supportCompareFlag">
              <div class="compare-select-box">
                <div class="version-item-box">
                  <div class="title dialog-label">更新前版本：</div>
                  <div class="common-select-box">
                    <el-select
                      class="primary-select"
                      size="small"
                      :popper-append-to-body="false"
                      v-model="fromVersion">
                      <el-option
                        v-for="(item, index) in versionList"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="split-icon">
                  <icon-svg icon-class="ic-duibi" />
                </div>
                <div class="version-item-box">
                  <div class="title dialog-label">更新后版本：</div>
                  <div class="common-select-box">
                    <el-select
                      :popper-append-to-body="false"
                      class="primary-select"
                      size="small"
                      v-model="toVersion">
                      <el-option
                        v-for="(item, index) in versionList"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="common-button-box"
                  v-if="isChecked('DataSet.VersionContrast.Create')">
                  <el-button
                    class="primary-btn"
                    type="text"
                    size="small"
                    @click="startCompare"
                    >发起对比</el-button
                  >
                </div>
              </div>
              <div class="split-line"></div>
              <div
                class="common-table-box"
                v-loading="tableLoading">
                <el-table
                  class="publish-small-table publish-table"
                  :header-row-class-name="customHeader"
                  ref="modelTable"
                  v-if="compareList.length"
                  :data="compareList"
                  height="100%">
                  <el-table-column
                    label="序号"
                    type="index"
                    width="75"></el-table-column>
                  <el-table-column
                    label="对比版本"
                    prop="versionDesc">
                  </el-table-column>
                  <el-table-column
                    label="对比状态"
                    width="120">
                    <template v-slot="{ row }">
                      <div
                        v-if="row.status === 0"
                        class="status-text">
                        <div class="circle circle-1 transform-run"></div>
                        <span class="transform-run">{{ row.statusDes }}</span>
                      </div>
                      <div
                        v-else-if="row.status === 1"
                        class="status-text">
                        <div class="circle circle-2 transform-success"></div>
                        <span class="color2 transform-success">{{
                          row.statusDes
                        }}</span>
                      </div>
                      <div
                        v-else-if="row.status === -1"
                        class="status-text">
                        <div class="circle circle-3 transform-fail"></div>
                        <span class="color3 transform-fail">{{
                          row.statusDes
                        }}</span>
                        <span
                          class="re-compare-icon transform-fail"
                          title="重新发起对比"
                          @click="reCompare(row)">
                          <icon-svg icon-class="ic-ico_upload" />
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="对比时间"
                    width="180">
                    <template v-slot="{ row }">
                      <div>{{ formatTime(row.contrastTime) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    v-if="isChecked('DataSet.VersionContrast.ViewContrast')">
                    <template v-slot="{ row }">
                      <div class="common-button-box operation-cell">
                        <el-button
                          type="text"
                          size="small"
                          :disabled="row.status !== 1"
                          @click="viewCompareResult(row)"
                          >查看模型</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              v-else
              class="common-empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">
                  <div>
                    当前版本对比功能仅针对以下来源格式：rvt、dgn、gim、3dm、xds
                  </div>
                </template>
              </bj-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common-button-box footer-box dialog-footer">
      <el-button
        type="primary"
        class="primary-btn primary-ang-btn"
        size="small"
        @click="cancel"
        >关闭</el-button
      >
    </div>
  </drag-dialog>
</template>

<script>
import dragDialog from '@/components/CustomDragDialog.vue'
import Spin from '@/components/Spin.vue'

import {
  isCompareService,
  startVersionContrast,
  getVersionContrastList
} from '@/service/interface'

import { formatTime } from '@/utils/generalMethods'

import { Store } from '@/utils/store'
import { isMicroAppMode, helper } from '@/microAdapt/utils'

export default {
  data() {
    return {
      title: '',
      activeTab: 'changeLogs',
      versionList: [],
      changeLogs: [],

      compareLoading: true,
      supportCompareFlag: false,
      fromVersion: 0,
      toVersion: 0,
      tableLoading: false,
      compareList: [],
      customHeader: '',
      timer: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      const currentBody = this.$refs.modelTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    })
  },
  props: {
    visible: Boolean,
    versionInfo: Object,
    closeDialog: Function
  },
  components: {
    dragDialog,
    Spin
  },
  watch: {
    versionInfo: function (newVal) {
      if (Object.keys(newVal).length) {
        this.title = newVal.dataSetName
        this.changeLogs = newVal.changeLogs
        this.versionList = this.formatVersion(newVal.successVersion)
        this.fromVersion = this.versionList[1].value
        this.toVersion = this.versionList[0].value
      }
    }
  },
  methods: {
    onTabClick(tabName) {
      this.activeTab = tabName
      if (tabName === 'versionCompare') {
        this.isCompareFlag().then(supportCompareFlag => {
          if (supportCompareFlag) {
            this.getCompareList()
          }
        })
      } else {
        this.timer && clearInterval(this.timer)
        this.timer = null
      }
    },
    isActive(activeTab) {
      return this.activeTab === activeTab
    },
    /**
     * 是否可以进行版本对比
     */
    isCompareFlag() {
      this.compareLoading = true
      return new Promise(resolve => {
        let dataSetId = this.versionInfo.dataSetId
        isCompareService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let supportCompareFlag = response.data
            this.supportCompareFlag = supportCompareFlag
            this.compareLoading = false
            resolve(supportCompareFlag)
          }
        })
      })
    },
    getCompareList() {
      this.tableLoading = true
      let dataSetId = this.versionInfo.dataSetId
      getVersionContrastList({ params: { dataSetId } }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let compareList = data.items

          this.timer && clearInterval(this.timer)
          this.timer = null
          let comparing = compareList.filter(el => el.status === 0)
          if (comparing.length) {
            this.timer = setInterval(this.refreshVersionCompareList, 5000)
          }

          this.compareList = compareList

          this.tableLoading = false
        }
      })
    },
    refreshVersionCompareList() {
      let dataSetId = this.versionInfo.dataSetId
      getVersionContrastList({ params: { dataSetId } }).then(response => {
        if (response.isSuccess) {
          let data = response.data

          let compareList = data.items
          let comparing = compareList.filter(el => el.status === 0)

          if (!comparing.length) {
            this.timer && clearInterval(this.timer)
            this.timer = null
          }
          this.compareList = compareList
        }
      })
    },
    cancel() {
      this.activeTab = 'changeLogs'
      this.closeDialog()
    },
    viewModel(versionInfo) {
      const routerUrl = this.$router.resolve({
        path: `../../versionView`,
        query: {
          dataSetId: this.versionInfo.dataSetId,
          dataSetName: this.versionInfo.dataSetName,
          versionId: versionInfo.version
        }
      })

      if (
        isMicroAppMode() &&
        typeof helper.versionSceneViewCallBack === 'function'
      ) {
        helper.versionSceneViewCallBack(routerUrl.href)
      } else {
        window.open(routerUrl.href, '_blank')
      }
    },
    startCompare() {
      if (this.fromVersion >= this.toVersion) {
        this.$message.warning('更新前的版本号必须小于更新后的版本号')
        return
      }

      let params = {
        dataSetId: this.versionInfo.dataSetId,
        fromVersion: this.fromVersion,
        toVersion: this.toVersion
      }
      this.tableLoading = true
      startVersionContrast(params).then(response => {
        if (response.isSuccess) {
          this.getCompareList()
        } else {
          this.tableLoading = false
          this.$message.warning(response.errMsg)
        }
      })
    },
    reCompare(data) {
      let params = {
        dataSetId: data.dataSetId,
        fromVersion: data.fromVersion,
        toVersion: data.toVersion
      }
      this.tableLoading = true
      startVersionContrast(params).then(response => {
        if (response.isSuccess) {
          this.getCompareList()
        } else {
          this.$message.warning(response.errMsg)
        }
      })
    },
    viewCompareResult(row) {
      let dataSetId = this.versionInfo.dataSetId
      let dataSetName = this.versionInfo.dataSetName
      let fromVersion = row.fromVersion
      let toVersion = row.toVersion

      const routerUrl = this.$router.resolve({
        path: `../../versionCompare`,
        query: {
          dataSetId: dataSetId,
          dataSetName: dataSetName,
          fromVersion: fromVersion,
          toVersion: toVersion
        }
      })

      if (
        isMicroAppMode() &&
        typeof helper.versionSceneViewCallBack === 'function'
      ) {
        helper.versionSceneViewCallBack(routerUrl.href)
      } else {
        window.open(routerUrl.href, '_blank')
      }
    },
    formatVersion(successVersion) {
      let versionList = []
      for (let i = 0; i < successVersion; i++) {
        let obj = {
          label: `V${i + 1}`,
          value: i + 1
        }
        versionList.push(obj)
      }
      versionList.reverse()
      return versionList
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.custom-tabs-box {
  display: flex;
  margin-top: -16px;
  .tabs-item-box {
    padding-top: 16px;
    padding-right: 16px;
    border-right: 1px solid var(--dialog-split-line-color);

    .tab-box {
      border-radius: 8px;
      width: 120px;
      font-size: 14px;
      padding: 6px 7px;
      margin-bottom: 16px;
      background: var(--tab-bgColor);
      color: var(--tab-text-color);
      text-align: center;
      cursor: pointer;

      &:hover {
        color: var(--tab-text-color);
        background-color: var(--tab-hover-bgColor);
      }

      &.active-item {
        color: var(--base-primary-bgColor);
        background-color: var(--base-bg-light-color24);
      }
    }
  }

  .tabs-content-box {
    padding-top: 16px;
    width: calc(100% - 137px);
    padding-left: 15px;

    .compare-box {
      width: 100%;
      height: 360px;
      margin-bottom: 10px;

      .loading-box {
        position: relative;
        width: 100%;
        height: 100%;
      }

      .compare-content-box {
        height: 100%;
      }

      .compare-select-box {
        display: flex;
        align-items: center;
        text-align: left;
        line-height: 32px;

        .version-item-box {
          display: flex;
          margin-right: 15px;
          font-size: 14px;

          .title {
            width: 150px;
          }

          .common-select-box {
            flex-grow: 1;
          }
        }

        .split-icon {
          font-size: 20px;
          color: var(--tab-icon-color);
          margin-right: 15px;
          display: flex;
          align-items: center;
        }
      }

      .split-line {
        margin-top: 10px;
        margin-left: -15px;
        width: calc(100% + 30px);
        height: 1px;
        background: var(--dialog-split-line-color);
      }

      .common-table-box {
        margin: 10px 0px;
        height: 300px;

        :deep(.el-loading-mask) {
          background-color: transparent;
        }

        :deep(.el-table) {
          .el-table__header-wrapper {
            border-radius: 4px;

            .el-table__header {
              .el-table__cell {
                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }

          .el-table__body-wrapper {
            tr {
              .el-table__cell {
                &:first-child {
                  border-radius: 4px 0 0 4px;
                }

                &:last-child {
                  border-radius: 0 4px 4px 0;
                }

                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }
        }

        .publish-small-table {
          :deep(.el-table__body) {
            -webkit-border-vertical-spacing: 4px;
            border-collapse: separate; /* 必须设置为 separate 才生效 */
            border-spacing: 0 4px; /* 水平间距 0，垂直间距 6px */
          }
        }

        .status-text {
          display: flex;
          .circle {
            width: 6px;
            height: 6px;
            margin: auto 10px auto 0px;
            border-radius: 50%;
            &-1 {
              background-color: var(--runing-status-color);
            }

            &-2 {
              background-color: var(--success-status-color);
            }

            &-3 {
              background-color: var(--error-status-color);
            }
          }

          .re-compare-icon {
            color: var(--error-status-color);
            margin: 0px 5px;
            cursor: pointer;
          }

          // .bg-color1 {
          //   background: #3588fa;
          // }

          // .bg-color2 {
          //   background: #73fbfd;
          // }

          // .bg-color3 {
          //   background: #f56c6c;
          // }

          // .color1 {
          //   color: #3588fa;
          // }

          // .color2 {
          //   color: #73fbfd;
          // }

          // .color3 {
          //   color: #f56c6c;
          // }
        }
      }

      .common-empty-box {
        color: var(--default-color);
      }
    }

    .changes-box {
      .common-table-box {
        margin-bottom: 10px;
        height: 360px;

        :deep(.el-table) {
          .el-table__header-wrapper {
            border-radius: 4px;

            .el-table__header {
              .el-table__cell {
                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }

          .el-table__body-wrapper {
            tr {
              .el-table__cell {
                &:first-child {
                  border-radius: 4px 0 0 4px;
                }

                &:last-child {
                  border-radius: 0 4px 4px 0;
                }

                &:nth-child(2) {
                  padding: 0px 10px;
                }
              }
            }
          }

          td .el-table__cell {
            border-color: transparent;
          }
        }
      }
    }
  }
}

.footer-box.dialog-footer {
  // margin-top: 10px;
  // margin-right: -10px;
  // text-align: right;
  margin: 0 -16px;
  width: calc(100% + 32px) !important;
  padding-bottom: 0 !important;
}
</style>
